import { useLocSettings } from "../../hooks/SettingsHooks";
import TrustpilotWidget from "../../components/TrustpilotWidget";
import "./style.scss";
import { transformHtml } from "../../utils/CmsUtils";

const FooterBottom = () => {
  const { footer } = useLocSettings();
  const trustpilotCode = footer.trustpilot_code;

  return (
    <footer role="contentinfo" className={"footer-bottom"}>
      <div
        className={"footer-bottom-container row no-gutters align-items-center"}
      >
        <div className={"col-6 col-sm-2 text-center"}>
          <div className="teh-certificate"></div>
        </div>
        <div className={"col-6 col-sm-2 order-sm-12 text-center"}>
          {/*TODO site picker*/}
        </div>
        <div className={"col-12 col-sm-8 text-center"}>
          {trustpilotCode && <TrustpilotWidget code={trustpilotCode} />}
        </div>
        <div
          className={"col-12 mt-5 mb-2"}
          style={{ fontSize: "0.75em", color: "#a4a4a4" }}
        >
          {transformHtml(footer.extra_content)}
        </div>
      </div>
    </footer>
  );
};

export default FooterBottom;
